import lodash from 'lodash';

export const clone = (entity, extender) => {
  return { ...lodash.cloneDeep(entity), ...extender };
};

export const onError = response => {
  console.error(response);
};



// WEBPACK FOOTER //
// ./app/javascript/common/common.js